'use strict';
export default {
    'title': {
        'en': 'Omniva e-service',
        'et': 'Omniva e-teenindus',
        'ru': 'Omniva e-service',
        'lv': 'Omniva e-pakalpojums',
        'lt': 'Omniva e-paslaugos'
    },
    'lang.et': {
        'en': 'Estonian',
        'et': 'Eesti',
        'ru': 'Эстония',
        'lv': 'Igaunija',
        'lt': 'Estija'
    },
    'lang.en': {
        'en': 'English',
        'et': 'Inglise'
    },
    'edit': {
        'en': 'Edit',
        'et': 'Muuda',
        'ru': 'Изменить',
        'lv': 'Mainīt',
        'lt': 'Pakeisti'
    },
    'delete': {
        'en': 'Delete',
        'et': 'Kustuta',
        'ru': 'Удалить',
        'lv': 'Dzēst',
        'lt': 'Pašalinti'
    },
    'save': {
        'en': 'Save',
        'et': 'Salvesta',
        'ru': 'Сохранить',
        'lv': 'Saglabāt',
        'lt': 'Išsaugoti'
    },
    'cancel': {
        'en': 'Cancel',
        'et': 'Katkesta',
        'ru': 'Отменить',
        'lv': 'Pārtraukt',
        'lt': 'Nutraukti'
    },
    'choose': {
        'en': 'Choose',
        'et': 'Vali',
        'ru': 'Выбрать',
        'lv': 'Izvēlēties',
        'lt': 'Pasirinkti'
    },
    'help': {
        'en': 'Help',
        'et': 'Abiinfo',
        'ru': 'Вспомогательная информация',
        'lv': 'Palīginformācija',
        'lt': 'Pagalba'
    },
    'optional': {
        'en': 'Optional',
        'et': 'Valikuline',
        'ru': 'Необязательный',
        'lv': 'Nav obligāts',
        'lt': 'Nebūtinas'
    },
    'e-mail': {
        'en': 'E-mail',
        'et': 'E-post',
        'ru': 'Электронная почта',
        'lv': 'E-pasts',
        'lt': 'El. paštas'
    },
    'add-another': {
        'en': 'Add another',
        'et': 'Lisan veel ühe',
        'ru': 'Добавить еще одного',
        'lv': 'Pievienot vēl vienu',
        'lt': 'Pridėti dar vieną'
    },
    'change': {
        'en': 'Change',
        'et': 'Muuda',
        'ru': 'Изменить',
        'lv': 'Mainīt',
        'lt': 'Pakeisti'
    },
    'close': {
        'en': 'Close',
        'et': 'Sulge',
        'ru': 'Закрыть',
        'lv': 'Aizvērt',
        'lt': 'Uždaryti'
    },
    'continue': {
        'en': 'Continue',
        'et': 'Jätka',
        'ru': 'Продолжить',
        'lv': 'Turpināt',
        'lt': 'Tęsti'
    },
    'yes': {
        'en': 'Yes',
        'et': 'Jah',
        'ru': 'Да',
        'lv': 'Jā',
        'lt': 'Taip'
    },
    'no': {
        'en': 'No',
        'et': 'Ei',
        'ru': 'Нет',
        'lv': 'Nē',
        'lt': 'Ne'
    },
    'success.save': {
        'en': 'Save successful',
        'et': 'Salvestamine õnnestus',
        'ru': 'Сохранение удалось',
        'lv': 'Saglabāšana izdevās',
        'lt': 'Išsaugota sėkmingai'
    },
    'error.required': {
        'en': '%s is mandatory',
        'et': '%s on kohustuslik',
        'ru': '%s является обязательным',
        'lv': '%s ir obligāts',
        'lt': '%s yra privalomas'
    },
    'error.minlength': {
        'en': 'Field length is below allowed limit',
        'et': 'Välja pikkus on alla lubatud piiri',
        'lv': 'Lauka garums ir mazāks par atļauto limitu',
        'lt': 'Įvesta laukelio reikšmė per trumpa'

    },
    'error.email': {
        'en': 'The e-mail address does not meet the standard. Please verify that your email address has the proper format: name@address.ee',
        'et': 'E-post ei vasta standardile. Palun kontrolli, kas sisestasid e-posti aadressi õiges formaadis: nimi@aadress.ee',
        'ru': 'Электронная почта не соответствуют стандарту. Пожалуйста, убедитесь, ввели ли Bы ​​адрес электронной почты в правильном формате: nimi@aadress.ee',
        'lv': 'E-pasts neatbilst standartam. Lūdzu, pārbaudiet, vai e-pasta adresi ievadījāt atbilstoši formātam: vārds@adrese.lv',
        'lt': 'El. paštas neatitinka standartų. Patikrinkite, ar el. pašto adresas įvestas teisinga forma, pvz: vardas@adresas.lt'
    },
    'error.url': {
        'en': 'Invalid format of webpage address',
        'et': 'Veebilehe aadressi formaat ei vasta nõuetele',
        'ru': 'Формат адреса веб-страницы не соответствует требованиям',
        'lv': 'Tīmekļa vietnes adreses formāts neatbilst prasībām',
        'lt': 'Internetinio puslapio adreso formatas neatitinka reikalavimų'
    },
    'error.phone': {
        'en': 'Invalid format of phone number',
        'et': 'Telefoninumbri formaat ei vasta nõuetele',
        'ru': 'Формат номера телефона не соответствует требованиям',
        'lv': 'Tālruņa numura formāts neatbilst prasībām',
        'lt': 'Telefono numerio formatas neatitinka reikalavimų'
    },
    'error.max-length': {
        'en': 'The maximum length of "%s" is %d characters',
        'et': 'Välja "%s" maksimaalne pikkus tohib olla %d tähemärki',
        'ru': 'Максимальная длина поля "%s" может быть %d символов',
        'lv': 'Lauka "%s" maksimālais garums var būt %d simboli',
        'lt': 'Didžiausias laukelio "%s" reikšmės ilgis gali būti %d simbolių'
    },
    'error.password': {
        'en': 'The password must consist of at least eight characters, include uppercase and lowercase letters and at least one number.',
        'et': 'Salasõna peab koosnema vähemalt kaheksast tähemärgist, sisaldama suuri ja väikeseid tähti ning vähemalt ühte numbrit.',
        'ru': 'Пароль должен состоять минимум из 8 символов, включать заглавные и прописные буквы и минимум одну цифру.',
        'lv': 'Parolei ir jābūt no vismaz 8 rakstzīmēm, jāietver lielos un mazos burtus un vismaz vienu ciparu.',
        'lt': 'Slaptažodį turi sudaryti mažiausiai 8 simboliai, įskaitant didžiąsias bei mažąsias raides ir bent vieną skaičių.'
    },
    'error.server': {
        'en': 'Error occured during request. Please check input data or try again later',
        'et': 'Päringu sooritamisel tekkis viga. Palun kontrolli sisendandmete korrektsust või proovi hiljem uuesti',
        'ru': 'При выполнении запроса возникла ошибка. Пожалуйста, проверьте корректность вводимых данных или попробуйте еще раз позже',
        'lv': 'Pieprasījuma izpildes laikā radās kļūda. Lūdzu, pārbaudi ievadāmo datu pareizību vai mēģini vēlāk vēlreiz',
        'lt': 'Užklausos vykdymo klaida. Patikrinkite įvestus duomenis arba bandykite dar kartą vėliau'
    },
    'error.signature': {
        'en': 'Error occured during signing process',
        'et': 'Viga allkirjastamisel',
        'ru': 'Ошибка при подписании',
        'lv': 'Radās kļūda parakstīšanas procesā',
        'lt': 'Pasirašymo proceso klaida'
    },
    'error.unique': {
        'en': 'Username is already in use',
        'et': 'Kasutajanimi on juba kasutusel',
        'ru': 'Имя пользователя уже используется',
        'lv': 'Lietotāja vārds jau tiek izmantots',
        'lt': 'Toks vartotojo atpažinimo kodas (vartotojo vardas) jau naudojamas'
    },
    'error.synced': {
        'en': 'Passwords entered do not match. Please enter them again.',
        'et': 'Sisestatud salasõnad ei ole samasugused. Palun sisesta salasõnad uuesti.',
        'ru': 'Введенные пароли не совпадают. Пожалуйста, введите пароли снова.',
        'lv': 'Ievadītās paroles nav vienādas. Lūdzu, ievadiet paroles vēlreiz.',
        'lt': 'Įvesti slaptažodžiai nesutampa. Pakartokite slaptažodžio vedimą dar kartą.'
    },
    'error.client': {
        'en': 'Service is disrupted, please try again later',
        'et': 'Teenuse töös esinevad tõrked, palun proovi hiljem uuesti',
        'ru': 'В работе услуг возникли неполадки, попробуйте позже снова',
        'lv': 'Pakalpojumu darbībā radušās kļūmes, mēģini vēlāk vēlreiz',
        'lt': 'Atsiprašome! Sutrikimai paslaugų teikimo darbe, bandykite dar kartą vėliau'
    },
    'error.person-code': {
        'en': 'The national identification number you entered is not valid in this country. Please enter the correct number.',
        'et': 'Sisestatud isikukood ei ole valitud riigis kehtiv. Palun kontrolli, kas sisestasid koodi õigesti.',
        'ru': 'Введенный идентификационный код личности в выбранной стране отсутствует. Пожалуйста, проверьте правильность введенного кода.',
        'lv': 'Personas kods, kuru Jūs ievadījāt, nav derīgs attiecīgajā valstī. Lūdzu, mēģiniet vēlreiz.',
        'lt': 'Jūsų asmens kodas negalioja pasirinktoje šalyje. Prašome įvesti teisingą identifikacijos numerį.'
    },
    'error.address': {
        'en': 'Address incorrect',
        'et': 'Sisestatud aadress ei ole korrektne',
        'lv': 'Ievadītā adrese nav pareiza',
        'lt': 'Įvestas adresas neteisingas'
    },
    'error.pattern': {
        'en': 'Invalid value',
        'et': 'Vigane väärtus',
        'lv': 'Nederīga vērtība',
        'lt': 'Neteisinga reikšmė'
    },
    'error.daterange': {
        'en': 'From date must be before end date',
        'et': 'Alguskuupäev peab olema lõpukuupäevast varasem',
        'ru': 'Начальная дата должна быть раньше конечной даты',
        'lv': 'Sākuma datumam jābūt pirms beigu datuma',
        'lt': 'Periodo pradžios data turi būti ankstesnė už galutinę datą'
    },
    'error.username': {
        'en': 'Username can only contain letters, numbers and a period',
        'et': 'Kasutajanimi tohib sisaldada ainult tähti, numbreid ja punkti',
        'ru': 'Имя пользователя может содержать только буквы, числа и точку',
        'lv': 'Lietotāja vārdā var būt tikai burti, skaitļi un punkts',
        'lt': 'Vartotojo atpažinimo kodas (vartotojo vardas) gali būti sudarytas tik iš raidžių, skaičių bei taško simbolių'
    },
    'error.auth': {
        'en': 'No rights to access component',
        'et': 'Komponendi nägemiseks puuduvad õigused',
        'ru': 'Отсутствуют права, чтобы увидеть компонент',
        'lv': 'Nav tiesību skatīt komponenti',
        'lt': 'Nesuteikta teisė matyti šį elementą'
    },

    'error.representation-failure': {
        'et': 'Hetkel ei ole %s kättesaadav. Proovi mõne aja pärast välja ning seejärel uuesti sisse logida. Vabandame võimalike ebamugavuste pärast.',
        'en': 'The %s is/are not available at the moment. After a while, please try to log out and log back in. We apologize for any inconvenience.',
        'ru': '%s не доступна(ы) в данный момент. Через некоторое время, попробуйте выйти и войти обратно. Приносим свои извинения за причиненные неудобства.',
        'lv': '%s ir / nav pieejams šobrīd. Vēlāk mēģiniet atslēgties un pieslēgties vēlreiz. Atvainojamies par sagādātajām neērtībām.',
        'lt': 'Deja, dėl techninių priežasčių šiuo metu %s neveikia. Bandykite prisijungti iš naujo vėliau. Nuoširdžiai atsiprašome už sukeltus nepatogumus.'
    },
    'error.service.LOGISTICS': {
        'et': 'Saadetiste vormistamine',
        'en': 'Shipment registration',
        'ru': 'Оформление отправлений',
        'lv': 'Sūtījuma noformēšana',
        'lt': 'Siuntų registravimas'
    },
    'error.service.PERIODICS': {
        'en': 'Periodicals',
        'et': 'Perioodika',
        'ru': 'Периодика',
        'lv': 'Periodicals',
        'lt': 'Periodicals'
    },
    'error.service.FINANCE': {
        'et': 'Arvete haldus',
        'en': 'Invoicing management',
        'ru': 'Управление счетами',
        'lv': 'Rēķinu administrācija',
        'lt': 'Sąskaitų faktūrų tvarkymas'
    },
    'error.service.recovered.autorefresh.FINANCE': {
        'et': 'Arvete haldus teenus on taastunud, iseteenindus värskendab end kümne sekundi pärast',
        'en': 'Invoice management service has been restored. E-service will be refreshed in about ten seconds',
        'lv': 'Rēķinu vadība pakalpojums tiek atjaunots, pašapkalpošanās vide tiks atjaunota pēc 10 sekundēm',
        'lt': 'Sąskaitų faktūrų tvarkymo paslauga atkurta. E-paslaugos atsinaujins maždaug už 10 sekundžių'

    },
    'error.service.recovered.refresh.FINANCE': {
        'et': 'Arvete haldus teenus on taastunud, enne teenuse kasutamist on vajalik veebilehte värskendada',
        'en': 'Invoice management service has been restored. It is necessary to refresh Your browser before using the service.',
        'lv': 'Rēķinu vadība pakalpojums ir atjaunots, pirms tā lietošanas ir nepieciešams atjaunot lapu',
        'lt': 'Sąskaitų faktūrų tvarkymo paslauga atkurta. Atnaujinkite šį puslapį savo naršyklėje prieš naudodamiesi paslaugomis'
    },

    'error.axapta.dead': {
        'et': 'Iseteeninduse töös esineb tõrkeid, sellega seoses ei ole hetkel võimalik seadeid vaadata/muuta ning sõlmida uut ärikliendi lepingut.',
        'en': 'You may encounter disruptions in self-service operations, therefore, it is currently not possible to view/change settings or sign a new business client contract.',
        'ru': 'Произошел сбой системы самообслуживания, в настоящий момент невозможно просмотреть/изменить настройки, а также заключить новый договор коммерческого клиента.',
        'lv': 'Ir radusies kļūme pašapkalpošanās sistēmā un šobrīd nav iespējams pārlūkot/mainīt iestatījumus, kā arī noslēgt jaunu komercklienta līgumu.',
        'lt': 'Dėl savitarnos sistemos veiklos sutrikimo šiuo metu neįmanoma peržiūrėti/pakeisti nustatymų bei sudaryti naują verslo kliento sutartį.',
    },

    'pager.total': {
        'en': 'Total',
        'et': 'Kokku',
        'ru': 'Всего',
        'lv': 'Kopā',
        'lt': 'Iš viso'
    },
    'pager.showing': {
        'en': 'Showing',
        'et': 'Kuvan',
        'ru': 'Показываю',
        'lv': 'Rādu',
        'lt': 'Rodoma'
    },
    'pager.first': {
        'en': 'First',
        'et': 'Esimene',
        'ru': 'Первая',
        'lv': 'Pirmā',
        'lt': 'Pirmas'
    },
    'pager.last': {
        'en': 'Last',
        'et': 'Viimane',
        'ru': 'Последняя',
        'lv': 'Pēdējā',
        'lt': 'Paskutinis'
    },
    'pager.next': {
        'en': 'Next',
        'et': 'Järgmine',
        'ru': 'Следующая',
        'lv': 'Nākamā',
        'lt': 'Kitas'
    },
    'pager.prev': {
        'en': 'Previous',
        'et': 'Eelmine',
        'ru': 'Предыдущая',
        'lv': 'Iepriekšējā',
        'lt': 'Ankstesnis'
    },
    'filter': {
        'en': 'Filter',
        'et': 'Filtreeri',
        'ru': 'Фильтровать',
        'lv': 'Filtrēt',
        'lt': 'Filtruoti'
    },
    'homepage': {
        'en': 'Homepage',
        'et': 'Avaleht',
        'ru': 'Сайт',
        'lv': 'Mājaslapa',
        'lt': 'Pradžia'
    },
    'address-not-found': {
        'en': "Didn't find Your address?",
        'et': 'Ei leidnud oma aadressi?',
        'ru': 'Не могу найти правильный адрес',
        'lv': 'Netiek atrasta pareizā adrese',
        'lt': 'Nerandate adreso?'
    },
    /* COUNTRIES-> */
    'country.EE': {
        'en': 'Estonia',
        'et': 'Eesti',
        'ru': 'Эстония',
        'lv': 'Igaunija',
        'lt': 'Estija'
    },
    'country.LV': {
        'en': "Latvia",
        'et': 'Läti',
        'ru': 'Латвия',
        'lv': 'Latvija',
        'lt': 'Latvija'
    },
    'country.LT': {
        'en': "Lithuania",
        'et': 'Leedu',
        'ru': 'Литва',
        'lv': 'Lietuva',
        'lt': 'Lietuva'
    },
    'country.ZZ': {
        'en': 'Other',
        'et': 'Muu',
        'ru': 'Другое',
        'lv': 'Cita',
        'lt': 'Kita'
    },
    /* <-COUNTRIES */
    /* ADDRESS COMPONENT-> */
    'address.placeholder': {
        'en': 'Street, house number, apartment, village, rural municipality, town',
        'et': 'Tänav, maja, korter, küla, vald, linn',
        'ru': 'Улица, дом, квартира, деревня, волость, город',
        'lv': 'Iela, māja, dzīvoklis, ciems, pagasts, pilsēta',
        'lt': 'Gatvė, namas, butas, kaimas, rajonas, miestas'
    },
    'address.desc': {
        'en': 'Enter the name of the street and the house number or the name of the farm. Then select the proper address from the generated list. If this address is not in the list, add the name of the town, village or township to the previously entered information and try again.',
        'et': 'Sisesta tänava nimi ja maja number või talu nimetus. Seejärel vali tekkinud nimekirjast õige aadress. Kui nimekirja sobivat aadressi ei tekkinud, lisa juba sisestatud infole linna või küla ja valla nimetus ning proovi uuesti.',
        'ru': 'Введите название улицы и номер дома или название хутора. Затем выберите из предложенного  списка правильный адрес. Если в списке нужный адрес не появился, введите правильное название города, деревни или поселка и повторите попытку.',
        'lv': 'Ievadiet ielas nosaukumu un mājas numuru, vai viensētas nosaukumu. Pēc tam no saraksta izvēlieties pareizo adresi. Ja sarakstā neparādās attiecīgā adrese, aizpildītajai informācijai pievienojiet pilsētas vai ciema un pagasta nosaukumu un mēģiniet vēlreiz.',
        'lt': 'Įveskite gatvės pavadinimą ir namo numerį arba gyvenvietės pavadinimą. Tuomet iš pateikto sąrašo pasirinkite teisingą adresą. Jeigu sąraše nėra pateiktas reikiamas adresas, papildykite jau pateiktą informaciją miesto arba kaimo ir rajono pavadinimais bei pabandykite pasirinkti adresą dar kartą.'
    },
    'address.manual': {
        'en': 'If you cannot find the correct address, please enter it manually in the text boxes below.',
        'et': 'Kui Sa ei leia nimekirjast õiget aadressi, sisesta palun aadress käsitsi siia lahtritesse.',
        'ru': 'Если Bы не можете найти в списке правильный адрес, пожалуйста, введите адрес вручную',
        'lv': 'Ja sarakstā neatrodat pareizo adresi, lūdzu, ievadiet to šajā lodziņā',
        'lt': 'Jei sąraše nerandate teisingo adreso, įveskite adresą rankiniu būdu į šį laukelį.'
    },
    'address.county': {
        'en': 'County',
        'et': 'Maakond',
        'ru': 'Уезд',
        'lv': 'Apriņķis',
        'lt': 'Apskritis'
    },
    'address.municipality': {
        'en': 'City / parish',
        'et': 'Linn / vald',
        'ru': 'Город / волость',
        'lv': 'Pilsēta / rajons',
        'lt': 'Miestas / rajonas'
    },
    'address.settlement': {
        'en': 'Settlement',
        'et': 'Asula',
        'ru': 'Hаселенный пункт',
        'lv': 'Apdzīvota vieta',
        'lt': 'Gyvenvietė'
    },
    'address.street': {
        'en': 'Street / house / apartment / farm',
        'et': 'Tänav / maja / korter / talu',
        'ru': 'Улица / дом / квартира /хутор',
        'lv': 'Iela / māja / dzīvoklis / viensēta',
        'lt': 'Gatvė / namas / butas / ūkis'
    },
    'address.zipCode': {
        'en': 'Postal code',
        'et': 'Sihtnumber',
        'ru': 'Почтовый индекс',
        'lv': 'Pasta indekss',
        'lt': 'Pašto kodas'
    },
    /* <-ADDRESS COMPONENT */
    /* LANGUAGES-> */
    'lang.ET': {
        'en': "estonian",
        'et': 'eesti keel',
        'ru': 'эстонский',
        'lv': 'igauņu valoda',
        'lt': 'estų kalba'
    },
    'lang.LV': {
        'en': "latvian",
        'et': 'läti keel',
        'ru': 'латышский',
        'lv': 'latviešu valoda',
        'lt': 'latvių kalba'
    },
    'lang.LT': {
        'en': 'lithuanian',
        'et': 'leedu keel',
        'ru': 'литовский',
        'lv': 'lietuviešu valoda',
        'lt': 'lietuvių kalba'
    },
    'lang.RU': {
        'en': "russian",
        'et': 'vene keel',
        'ru': 'русский',
        'lv': 'krievu valoda',
        'lt': 'rusų kalba'
    },
    'lang.EN': {
        'en': "english",
        'et': 'inglise keel',
        'ru': 'английский',
        'lv': 'angļu valoda',
        'lt': 'anglų kalba'
    },
    /* <-LANGUAGES */
    'begin': {
        'en': 'Begin',
        'et': 'Algus',
        'ru': 'Начало',
        'lv': 'Sākums',
        'lt': 'Pradžia'
    },
    'end': {
        'en': 'End',
        'et': 'Lõpp',
        'ru': 'Конец',
        'lv': 'Beigas',
        'lt': 'Pabaiga'
    },
    'unlimited': {
        'en': 'Unlimited',
        'et': 'Tähtajatu',
        'ru': 'Бессрочный',
        'lv': 'Beztermiņa',
        'lt': 'Neterminuota'
    },
    'not-active': {
        'en': 'Inactive',
        'et': 'Mitteaktiivne',
        'ru': 'Неактивный',
        'lv': 'neaktīvs',
        'lt': 'neaktyvus'
    },
    'active': {
        'en': 'Active',
        'et': 'Aktiivne',
        'ru': 'Активный ',
        'lv': 'aktīvs',
        'lt': 'aktyvus'
    },
    /* +----------------------+ */
    /* +---+ Applications +---+ */
    /* +----------------------+ */
    'app.FINANCE': {
        'en': 'Manage invoices',
        'et': 'Halda arveid',
        'ru': 'Управлять счетами',
        'lv': 'Administrēt rēķinus',
        'lt': 'Tvarkyti sąskaitas faktūras'
    },
    'app.LOGISTICS': {
        'en': 'Register parcels',
        'et': 'Vormista pakk',
        'ru': 'Оформить посылку',
        'lv': 'Noformēt sūtījumu',
        'lt': 'Registruoti siuntas'
    },
    'app.PERIODICALS': {
        'en': 'Periodicals',
        'et': 'Perioodika',
        'ru': 'Периодика',
        'lv': 'Periodicals',
        'lt': 'Periodicals'
    },
    'pref.service': {
        'en': 'Choose the service you wish to enter after logging in',
        'et': 'Vali, millisesse teenusesse suundud pärast sisselogimist',
        'ru': 'Выбрать, к какой услуге Вы обратитесь после выполнения входа',
        'lv': 'Izvēlieties, uz kuru pakalpojumu virzīties pēc pievienošanās',
        'lt': 'Pasirinkite, kokiomis Omniva paslaugomis dažniausiai naudositės po prisijungimo'
    },
    'pref.represented': {
        'en': 'Choose the person you want to represent after logging into the e-service',
        'et': 'Vali, keda soovid esindada pärast e-teenindusse sisselogimist',
        'ru': 'Выберите, кого Вы желаете представлять после выполнения входа в э-обслуживание',
        'lv': 'Izvēlieties, kuru personu vēlaties pārstāvēt pēc pievienošanās e-pakalpojumam',
        'lt': 'Pasirinkite, kokią įmonę dažniausiai atstovausite po prisijungimo'
    },
    'pref.represented.none': {
        'en': 'I do not wish to determine a default representative.',
        'et': 'Ei soovi vaikimisi esindatavat määrata',
        'ru': 'Не определять предстовляемого по умолчянию',
        'lv': 'Noklusējuma pārstāvji nav',
        'lt': 'Nepageidauju pasirinkti numatytojo atstovaujamojo'
    },
    'pref.PACKAGE-PRIVATE': {
        'en': 'Register parcels (Private)',
        'et': 'Erakliendi pakkide vormistamine',
        'ru': 'Оформление посылок (частный клиент)',
        'lv': 'Reģistrēt sūtījumus (privāts)',
        'lt': 'Siuntų registravimas (privatiems)'
    },
    'pref.LOGISTICS': {
        'en': 'Register parcels (Business)',
        'et': 'Ärikliendi saadetiste vormistamine',
        'ru': 'Оформление посылок (бизнес клиент)',
        'lv': 'Reģistrēt sūtījumus (bizness)',
        'lt': 'Siuntų registravimas (verslui)'
    },
    'pref.FINANCE': {
        'en': 'Invoice management',
        'et': 'Arvete haldus',
        'ru': 'Управление счетами',
        'lv': 'Rēķinu pārvaldība',
        'lt': 'Sąskaitų faktūrų tvarkymas'
    },
    'pref.NOPREFERENCE': {
        'en': 'No default service',
        'et': 'Ei soovi vaikimisi teenust määrata',
        'ru': 'Не желаю настраивать услугу по умолчанию',
        'lv': 'Noklusējuma pakalpojuma nav',
        'lt': 'Nėra numatytos paslaugos'
    },
    'server.maintenance.title': {
        'en': 'Sorry!',
        'et': 'Vabandame!',
        'ru': 'Извините!',
        'lv': 'Atvainojiet!',
        'lt': 'Brangus kliente!'
    },
    'server.maintenance.desc': {
        'en': 'Due to technical issues, the functioning of our e-service is currently disrupted. We are working on a solution. We apologise for the inconvenience!',
        'et': 'Tehnilise rikke tõttu on hetkel meie e-teeninduse töö häiritud. Probleemi lahendamisega tegeletakse. Vabandame ebamugavuste pärast!',
        'ru': 'Из-за технических неполадок работа нашей системы э-обслуживания была нарушена. Мы работаем над решением. Приносим извинения за доставленные неудобства!',
        'lv': 'Tehnisku traucējumu dēļ, šobrīd mūsu e-servisa darbība ir ierobežota. Šobrīd strādājam pie risinājuma. Atvainojamies par sagādātajām neērtībām.',
        'lt': 'Dėl techninių trikdžių šiuo metu neveikia mūsų e-paslaugos. Dedame visas pastangas kuo skubiau pašalinti gedimą. Atsiprašome už nepatogumus!'
    },
    'menu': {
        'en': 'Menu',
        'et': 'Menüü',
        'ru': 'Меню',
        'lv': 'Izvēlne',
        'lt': 'Meniu'
    }
};


// WEBPACK FOOTER //
// ./src/ui/core/common/translations/core.translations.ts